import createLucideIcon from '../createLucideIcon';

const MinusCircle = createLucideIcon('MinusCircle', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['line', { x1: '8', x2: '16', y1: '12', y2: '12', key: '1jonct' }],
]);

export default MinusCircle;
